import { render } from "./ReplyManager.vue?vue&type=template&id=7d794c5f&scoped=true"
import script from "./ReplyManager.vue?vue&type=script&lang=js"
export * from "./ReplyManager.vue?vue&type=script&lang=js"

import "./ReplyManager.vue?vue&type=style&index=0&id=7d794c5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d794c5f"]])

export default __exports__